import { getMemberKey, getNodeLabel, getProjectData, splitUid, getUid, getNamespaceValue } from 'Services/WeaverUtils'
import { store } from '~/Store'
import { Tag } from 'antd'
import Feather from '@sysunite/react-feather'
import ColorService from 'Services/ColorService'
import Promise from 'bluebird'

renderDotIfType = (node) ->
  if typeRel = node.relationsIn[getMemberKey()]
    typeId = typeRel.first().id()
    color = ColorService.getColorForType(typeId)
    <Feather width="1em" height="1em" type="circle" style={{ marginRight: 5, fill: color, color }} />
  else
    ''

onlyFrom = (context, relname, oldSelected, newSelected) ->
  if !oldSelected? and !newSelected?
    return
  if oldSelected?.equals(newSelected)
    return

  if oldSelected?
    oldSelected.relation(relname).remove(context)
    oldSelected.save()
  if newSelected?
    newSelected.relation(relname).add(context)
    newSelected.save()

renderTagIfGraph = (node) ->
  if graph = getUid(node)?.split('@')[1]
    <Tag style={{ marginLeft: 5 }}>{ graph }</Tag>

getNodeListOrNode = (nodes, formItemType) ->
  if ['select', 'selectOrCreate'].indexOf(formItemType) is -1 then nodes[0] else nodes

export getFirstAttr = (node, attrs...) ->
  node.get(
    attrs.find((attr) -> node.get(attr))
  ) or node.nodeId

getNodeRelations = (formFields) ->
  relationFields = formFields.filter(({ save })-> save?.type is 'relation')

  relationsInFields = relationFields.filter(({ save })-> save.relationName and save.orientation? and save.orientation is 'IN')
  relationsOutFields = relationFields.filter(({ save })-> save.relationName and save.orientation isnt 'IN')
  {
    relationsIn: relationsInFields.map(({ save: { relationName } }) -> relationName)
    relationsOut: relationsOutFields.map(({ save: { relationName } }) -> relationName)
  }

export loadNodeData = (nodeId, formFields) ->
  { relationsIn, relationsOut } = getNodeRelations(formFields)

  query = new Weaver.Query()
    .restrict(nodeId)
    .selectOut(getMemberKey())
  relationsIn.map((relIn)-> query.selectIn(relIn))
  relationsOut.map((relOut) -> query.selectOut(relOut))
  await query.first()

mapFormValues = (value, mapValues = []) ->
  mapValues.find((v)->
    v.from is value
  )?.to or value

mapBooleanValues = (value, save = {}) ->
  { onKey, offKey } = save
  return value if !onKey && !offKey
  if value
    onKey.value
  else
    offKey.value

export getNodeValue = (node, attr) ->
  if attr then node.get(attr) else node.id()

export createFormItemName = (formItem, value, prefix) ->
  "#{ formItem }-#{ prefix?.replace(/\s+/g, '-') or '' }-#{ value.replace?(/\s+/g, '-') or value }"

# Executes the query specified in the config
export getDataOptions = (queries, derivedData, parameters = {}) ->
  { querySource, labelAttr, valueAttr } = derivedData
  try # may get a `Missing parameter` error if a required form field is empty
    options = await _.clone(queries[querySource]).build(parameters).unlimited()
  catch # In such cases, return 0 results
    return []
  options.map((node) ->
    attributeValue = node.get(labelAttr) or node.get(valueAttr) or getNodeLabel(node)
    label = (
      <span>
        { renderDotIfType(node) }
        { attributeValue }
        { renderTagIfGraph(node) }
      </span>
    )

    {
      label
      value: getUid(node)
      attributeValue
    }
  )

# creates an object of all attribute values according to the accepted format
# for Ant's form. When the save.attributes config is specified the values will
# be joined under the mentioned  field.
# {
#   formItem1: 'value 1'
#   formItem2: { value1: 'value 1', value2: 'value 2'}
# }
mapAttributesToFormFields = (node, formFields) ->
  formFields
    .filter(({ save }) -> not save or save?.type isnt 'relation')
    .reduce((fieldAcc, { formItem, config, save }) ->
      itemValue = (
        save?.attributes?.reduce((attAcc, value) ->
          { attAcc..., [value]: node.get(value) }
        , {}) or mapBooleanValues(node.get(formItem), save)
      )
      { fieldAcc..., [formItem]: itemValue }
    , {})

# creates an object of all incoming relations to the current node. To assign
# nodes in the result set to the according formItem the memberKey of the
# specified querySource (of the formitem) will be used to determine weather
# the node is of the specified type.
# {
#   formItem3: ['nodeId1', 'nodeId2']
#   formItem4: ['nodeId3']
# }
mapIncomingRelationsToFormFields = (node, formFields, dataQueries) ->
  await Promise.reduce(
    formFields.filter(({ save })-> save?.orientation is 'IN'), (acc, {
      formItem
      derivedData: { querySource, labelAttr }
      save: { relationName }
    })->
      sourceData = await dataQueries[querySource]?.build().find()
      { acc..., [formItem]: node
        .relationIn(relationName)
        .all()
        .filter((n)->
          node.relationIn(relationName).all().map((rel) -> rel.id()).indexOf(n.id()) isnt -1
        ).map((n)->
          getUid(n)
        )
      }
  , {})

# creates an object of all outgoing relations from the current node.
# {
#   formItem5: ['nodeId4', 'nodeId5']
#   formItem6: ['nodeId6']
# }

mapOutgoingRelationsToFormFields = (node, formFields) ->
  formFields
    .filter(({ save }) -> save?.type is 'relation' and save?.orientation isnt 'IN')
    .reduce((acc, { formItem, formItemType, derivedData, save }) ->
      nodes = node.relation(save.relationName).all().map((n) -> getUid(n))
      itemValue = getNodeListOrNode(nodes, formItemType)
      { acc..., [formItem]: itemValue }
    , {})

###
 # @desc return an object with additional data that provide a relevant other
 # form field, it's value and the respective Weaber node.
###
getDerivedData = (form, formData, fields, derivedData) ->
  fieldValue = form.getFieldValue(derivedData.sourceField)
  refField = fields.find(({ formItem })-> formItem is derivedData.sourceField)
  refValue = if Array.isArray(fieldValue) then fieldValue[0] else fieldValue
  refNode = formData[refField.derivedData.querySource].find((node)->
    getNodeValue(node, refField.derivedData.queryAttr) is refValue
  )
  { refField, refValue, refNode }

###
 # @desc creates an object with additional data that will be used when rendering
 # the element. This config consists of:
 # - the default field configuration (as specified in the main config).
 # - the configuration per field that will be merged. (optional)
 # - referableData that will provide relevant other form values and results from
 #   queries. (optional)
###
export getFieldConfig = (form, formData, fields, field) ->
  fieldConfig = fields.find(({ formItem })-> formItem is field)
  { formItem, config, derivedData } = fieldConfig
  if derivedData?.sourceField
    fieldConfig.referableData = getDerivedData(form, formData, fields, derivedData)
  fieldConfig

countRepeatOnAttribute = (nodeId, path) ->
  [relationKeys..., attributeKey] = path.split('.')
  [id, graph] = splitUid(uid)
  return unless id
  node = await new Weaver.Query()
    .restrict(id)
    .inGraph(graph)
    .selectOut(relationKeys...)
    .first()
  while relKey = relationKeys.shift()
    node = node.relation(relKey).first()
  node.get(attributeKey)

export getRepeatCount = (form, repeatConf) ->
  if _.isString(repeatConf)
    form.getFieldValue(repeatConf)
  else if repeatConf?
    { item, type, key = '' } = repeatConf
    if type is 'attr'
      await countRepeatOnAttribute(form.getFieldValue(item)?[0], key)
    else if type is 'count'
      form.getFieldValue(item)?.length
  else
    1

# creates an object with all node values assigned to the form inputs, as
# specified in the config
export getNodeData = (nodeId, formFields, dataQueries) ->
  node = await loadNodeData(nodeId, formFields)
  attributeValueMap = mapAttributesToFormFields(node, formFields)
  relationsInValueMap = await mapIncomingRelationsToFormFields(node, formFields, dataQueries)
  relationsOutValueMap = mapOutgoingRelationsToFormFields(node, formFields)
  { attributeValueMap...,  relationsInValueMap..., relationsOutValueMap... }

getFormDataNodes = (nodeIds) ->
  inGraphIds = []
  notInGraphIds = []
  nodeIds.map((id) -> if id.includes('@') then inGraphIds.push(id) else notInGraphIds.push(id))
  inGraphNodes = await new Weaver.Query().restrict(inGraphIds).find()
  notInGraphNodes = await new Weaver.Query().restrict(notInGraphIds).inGraph(undefined).find()
  [inGraphNodes..., notInGraphNodes...]

processRelationField = ({ formField, subject, dataQuery, saveConf }) ->
  { value, initialValue, fieldConfig: { save, derivedData }} = formField
  { relationName, dataAttr, orientation, relationThrough } = save
  { querySource, queryAttr } = derivedData

  unless _.isArray(value) or _.isString(value) or _.isUndefined(value)
    value = _.values(value)

  formDataNodeIds = if _.isArray(value) then value else [value]
  formDataNodes = await getFormDataNodes(formDataNodeIds)

  if orientation is 'IN'
    oldSelected = if initialValue? then await Weaver.Node.load(initialValue[0]) else undefined
    await onlyFrom(subject, relationName, oldSelected, formDataNodes[0])
  else
    await subject.relation(relationName).onlyTo(formDataNodes)
    subject.save({ commitMessage: "Create #{ relationName } relation." })

setAttribute = (fn, key) -> ({ value, save, subject }) ->
  if _.isPlainObject(value)
    if save?.attributes
      save.attributes.map((attr)->
        if value[attr]
          try
            subject[fn](attr, value[attr])
      )
    else
      _.keys(value).map((key)->
        if value[key]
          try
            subject[fn](key, value[key])
      )
  else
    try
      subject[fn](key, value)

findIdFromFormField = (formFields) ->
  for key, struct of formFields
    if key.toLowerCase() is 'id'
      return getNamespaceValue(struct.value)

processAttributeField = ({ key, formField, subject, saveConf }) ->
  { value, fieldConfig: { save = {}, mapValues, config }} = formField

  value = mapFormValues(value, mapValues)
  value = mapBooleanValues(value, save)

  if value?
    fn = setAttribute('set', key)
  else
    fn = setAttribute('unset', key)

  fn({ value, save, subject })

processFormField = ({ key, subject, formField, saveConf, dataQuery }) ->
  if formField.fieldConfig?.save?.type is 'relation'
    fn = processRelationField
  else
    fn = processAttributeField
  fn({ key, formField, subject, saveConf, dataQuery })

setNodeType = (subject, { node: { typeNode, typeLabel, typeGraph }, config}) ->
  newNode = await Weaver.Node.firstOrCreate(typeNode, undefined, typeGraph or config?.graph)
  newNode.set('name', typeLabel) if typeLabel?
  subject.relation(getMemberKey()).add(newNode)
  subject.save({ commitMessage: "Add type for #{ subject.id() } through relation." })

processFormData = (onFinish) -> (nodeId, formFields, saveConf, dataQueries) ->
  if nodeId
    subject = await new Weaver.Query().restrict(nodeId).selectIn('*').first()
  else
    id = findIdFromFormField(formFields)
    subject = new Weaver.Node(id, saveConf.node.graph)
  await Promise.all(_.map(formFields, (formField, key) ->
    dataQuery = dataQueries[formField.fieldConfig?.derivedData?.querySource]
    if key.toLowerCase() isnt 'id'
      processFormField({ key, subject, formField, saveConf, dataQuery })
  ))

  await onFinish?(subject, formFields, saveConf, dataQueries)
  await subject.save({ commitMessage: "Save main node (from Form)." })
  subject

export createFormData = processFormData((subject, formFields, saveConf, dataQueries) ->
  if saveConf?.node?.typeNode
    await setNodeType(subject, saveConf)
)

export editFormData = processFormData()

comparatorTypes = {
  EQUAL_TO: _.isEqual
  NOT_EQUAL_TO: (left, right) -> !_.isEqual(left, right)
  GREATER_THAN: _.gt
  LESS_THAN: _.lt
}

export fieldShouldRender = (form, conditions = []) ->
  conditions.map((condition) ->
    if _.isString(condition)
      form.getFieldValue(condition)
    else
      { key, type, value } = condition
      comparatorTypes[type](value, form.getFieldValue(key))
  ).every((passedCheck) ->
    passedCheck
  )

